import React from 'react';
import classNames from 'classnames';

import css from './MenuItem.css';

const MenuItem = props => {
  const { children, className, rootClassName } = props;
  const rootClass = rootClassName || css.root;
  const classes = classNames(rootClass, className);

  return (
    <li className={classes} role="menuitem">
      {children}
    </li>
  );
};

export default MenuItem;
